"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Auth = void 0;
const msal_browser_1 = require("@azure/msal-browser");
const Cookies = require("js-cookie");
const cookieAttributes = {
  path: "/",
  sameSite: "Lax",
  secure: true
};
function isSameOrigin(path) {
  const expectedOrigin = new URL(document.baseURI).origin;
  const actualOrigin = new URL(path, document.baseURI).origin;
  return expectedOrigin === actualOrigin;
}
// Normally when we reach the /callback url that AzureAd redirected us to,
// msal-browser will NOT handle the hash but redirect to target page first,
// leaving it to the actual target page to trade the authorization code for
// a token. This will not work because the target page may only be accessable
// if we are authenticated. This DelayedNavigationClient now only store a
// site we want to navigate to. We can then later navigate to it with navigateNow
class DelayedNavigationClient extends msal_browser_1.NavigationClient {
  constructor() {
    super(...arguments);
    this.delayedNavigation = null;
  }
  navigateNow() {
    if (this.delayedNavigation) {
      const {
        url,
        options
      } = this.delayedNavigation;
      this.delayedNavigation = null;
      if (options.noHistory) {
        window.location.replace(url);
      } else {
        window.location.assign(url);
      }
      return new Promise(function (resolve) {
        setTimeout(function () {
          resolve(true);
        }, options.timeout);
      });
    }
    return Promise.resolve(false);
  }
  async navigateInternal(url, options) {
    const sanitizedUrl = isSameOrigin(url) ? url : "/";
    this.delayedNavigation = {
      url: sanitizedUrl,
      options
    };
    return false;
  }
}
class Auth {
  constructor(clientId, tenantId, redirectUri) {
    let scopes = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : ["openid", "profile"];
    const configuration = {
      auth: {
        clientId: clientId,
        authority: `https://login.microsoftonline.com/${tenantId}`,
        redirectUri: redirectUri,
        navigateToLoginRequestUrl: true
      },
      cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false // Set this to "true" if you are having issues on IE11 or Edge
      }
    };

    this.clientId = clientId;
    this.scopes = scopes;
    this.client = new msal_browser_1.PublicClientApplication(configuration);
    this.navClient = new DelayedNavigationClient();
    this.client.setNavigationClient(this.navClient);
  }
  loginWithRedirect(requestedUri) {
    const redirectStartPage = requestedUri && isSameOrigin(requestedUri) ? requestedUri : "/";
    return this.client.loginRedirect({
      scopes: this.scopes,
      redirectStartPage
    });
  }
  async handleRedirectCallback() {
    const result = await this.client.handleRedirectPromise();
    if (result !== null) {
      /* We came from a redirect. Let's handle it */
      const {
        account,
        idToken
      } = result;
      if (account) {
        const claims = account.idTokenClaims;
        if (claims && claims.oid) {
          this.client.setActiveAccount(account);
          Cookies.set(`AzureADIdentifyServiceProvider.${this.clientId}.LastAuthUser`, claims.oid, cookieAttributes);
          Cookies.set(`AzureADIdentifyServiceProvider.${this.clientId}.${claims.oid}.idToken`, idToken, cookieAttributes);
        }
      }
    }
  }
  async navigateNow() {
    return this.navClient.navigateNow();
  }
}
exports.Auth = Auth;
//# sourceMappingURL=auth.js.map